var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoQualityCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15C3.33984 15 0 11.6602 0 7.5C0 3.36914 3.33984 0 7.5 0C11.6309 0 15 3.36914 15 7.5C15 11.6602 11.6309 15 7.5 15ZM10.8105 6.12305H10.7812C11.0742 5.85938 11.0742 5.41992 10.7812 5.12695C10.5176 4.86328 10.0781 4.86328 9.81445 5.12695L6.5625 8.4082L5.18555 7.03125C4.89258 6.73828 4.45312 6.73828 4.18945 7.03125C3.89648 7.29492 3.89648 7.73438 4.18945 7.99805L6.06445 9.87305C6.32813 10.166 6.76758 10.166 7.06055 9.87305L10.8105 6.12305Z",
    fill: "#EFF2F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoQualityCheckIcon);
export default __webpack_public_path__ + "static/media/videoQualityCheckIcon.9ad7b928792aa1a0964933a0b60be477.svg";
export { ForwardRef as ReactComponent };